export const NEWSLETTER_ENDPOINTS = {
  SUSCRIBIR: '/api/v1/newsletter/suscribir',
} as const;
